const getHost = () => {
  if (process.env.NODE_ENV === 'development') {
    return 'http://localhost:8080';
  }
  return '';
  // return 'http://192.168.200.199:8080';
};

export const host = getHost();
